import { isSelfHosted } from "@/helpers/self-hosted.helper"

import { AuthAdapter as AuthAdapterFirebase } from "./auth-adapter"
import { AuthAdapter as AuthAdapterSelfHosted } from "./auth-adapter.self-hosted"

const AuthAdapter = isSelfHosted() ? AuthAdapterSelfHosted : AuthAdapterFirebase

export { AuthAdapter }

export type { InitialParamsAuthAdapter } from "./auth-adapter"
